import * as TooltipPrimitive from "@radix-ui/react-tooltip";

export interface TooltipProps {
  content: string;
  children: React.ReactNode;
}

export function Tooltip({ content, children }: TooltipProps) {
  return (
    <TooltipPrimitive.Provider delayDuration={200}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            className="text-text-dim z-50 max-w-[240px] animate-[fadeIn_0.15s_ease] rounded-sm border border-[var(--glass-border)] bg-[var(--glass-bg)] px-3 py-2 font-mono text-[10px] [backdrop-filter:var(--glass-blur)]"
            sideOffset={5}
          >
            {content}
            <TooltipPrimitive.Arrow className="fill-[var(--glass-border)]" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
